import { FormGroup, Input, Label, Tooltip, FormFeedback } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkInput } from "../../Utils/otherFunctions";
import { forwardRef, useState } from "react";
import { Info } from "react-feather";

const InputField = forwardRef(function InputField(props, ref) {
  const { label, className, fieldState, placeholder, valid, validFeedback } = props;
  const { themeContext } = useThemeContext();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <FormGroup className={className}>
      {label && (
        <Label className={`bg-transparent`}>
          {label}{" "}
          {props.isRequired && (
            <font className="ml-1" color="red">
              *
            </font>
          )}
          {
            props.tooltip && <Info id={`tooltip-${props.name}`} size={10} />
          }
        </Label>
      )}
      <Input
        className={`${getDarkInput(themeContext)} ${className}`}
        style={{ border: '1px solid black' }}
        invalid={!!fieldState?.error}
        valid={valid}
        type="text"
        placeholder={placeholder}
        ref={ref}
        {...props}
      />
      {fieldState?.error && (
        <Label className={"label-text text-danger"}>
          {fieldState.error.message}
        </Label>
      )}
      {valid && validFeedback && (
        <FormFeedback valid>{validFeedback}</FormFeedback>
      )}
      {
        props.tooltip && (
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target={`tooltip-${props.name}`}
            toggle={toggle}
          >
            {props.tooltip}
          </Tooltip>
        )
      }
    </FormGroup>
  );
});

export default InputField;